import { html, repeat, ref } from '@microsoft/fast-element';
import type { BasketListing } from './basket-listing';
import { BASKET_LISTING_COLUMNS } from './column-config';

export const BasketListingTemplate = html<BasketListing>`
  <zero-grid-pro
    class="grid-styles"
    only-template-col-defs
    sideBar=""
    rowSelection="single"
    ${ref('basketListingGrid')}
    @onGridReady="${(x) => x.onGridReady()}"
  >
    ${repeat(
      (x) => BASKET_LISTING_COLUMNS(x),
      html`
        <grid-pro-column :definition="${(x) => x}"></grid-pro-column>
      `
    )}
  </zero-grid-pro>
`;
